<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch', //check
            'btnSave'
          ]"
          @btnSearch="btnSearch()"
          @btnSave="btnSave()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">
                <i-label :label="'Mid PFD Period   From '" class="pl-2"/>
                <v-col cols="auto" class="pa-0">
                   <DxDateBox                        
                        :value="FDate"
                        height="30px"
                        width="120px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {FDate = e.value; FDateStr = e.value && getStrFormat(e.value)}"
                    />
                </v-col>
                <span class="_label">To</span>
                <v-col cols="auto" class="pa-0">
                   <DxDateBox                        
                        :value="TDate"
                        height="30px"
                        width="120px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {TDate = e.value; TDateStr = e.value && getStrFormat(e.value)}"
                    />
                </v-col>

                <span class="_label"> </span>
                <i-label :label="'Ship No '" class="pl-2"/>
                <v-col cols="auto" class="pa-0">
                  <v-select
                    v-model="shipNo"
                    :items="listShip"
                    :item-value="`code`"
                    :item-text="`name`"
                    width="120px"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    clearable
                  ></v-select>
                </v-col>

                <span class="_label"> </span>
                <i-label :label="'Block : '" class="pl-2"/>
                <v-col cols="auto" class="pa-0">
                <v-text-field 
                    v-model="block"
                    dense
                    outlined
                    hide-details="auto"
                    :maxlength="4"
                    @input="limitInput"
                    @keyup="uppercase"
                  />                                                  
                </v-col>    

              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pa-2">
        <i-card-vertical
          style="color: black"
          headerTitle="Sub-Assembly OutSide Control"
        >
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="bas0010MainGrid"
                  class="listBox"
                  :ref="dxDataGridRef"
                  :data-source="bas0010MainGrid"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :show-borders="true"
                  :width="grid.width"
                  :show-row-lines="true"
                  :height="'auto'"
                  key-expr="id"
                  :focused-row-enabled="true"
                  :disablePagination="false"
                  :column-hiding-enabled="false"
                  :column-auto-width="false"
                  :on-row-inserted="e => e.component.navigateToRow(e.key)"
                  @editing-start="bas0010EditingStart"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <DxEditing :allow-updating="true" :allow-adding="true" mode="cell" />
                  <DxSelection select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple"  />
                  <DxColumn
                    data-field="shipno"
                    :caption="$t('Ship No')"
                    width="100"
                    data-type="string"
                    alignment="center"
                    css-class="grid-header-bold"
                    :allow-editing="false" />

                  <DxColumn
                    data-field="block"
                    :caption="$t('Block')"
                    width="80"
                    data-type="string"
                    alignment="center"
                    css-class="grid-header-bold"
                    :allow-editing="false" />

                  <DxColumn
                    data-field="lotno"
                    :caption="$t('Lot')"
                    width="60"
                    data-type="string"
                    alignment="center"
                    css-class="grid-header-bold"
                    :allow-editing="false"  />

                  <DxColumn
                    data-field="ppWeight"
                    :caption="$t('PP Weight')"
                    width="100"
                    data-type="number"
                    alignment="center"
                    css-class="grid-header-bold"
                    :allow-editing="false" />

                  <DxSummary>
                    <DxTotalItem
                      column="ppWeight"
                      summary-type="sum"
                      display-format="Total: {0}"
                      value-format="#,##0.0"
                      alignment="left"
                    />
                  </DxSummary>

                  <DxColumn
                    data-field="respnm"
                    :caption="$t('WorkGroup')"
                    width="180"
                    data-type="string"
                    alignment="center"
                    css-class="grid-header-bold"
                    :allow-editing="false"
                  />
                  <DxColumn caption="Mid PP Schedule (Sub-Assembly)" width="300" alignment="center" css-class="grid-header-bold">
                    <DxColumn
                      data-field="wkstpldt"
                      caption="PSD"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                    :allow-editing="false"
                    css-class="grid-header-bold"
                    />
                    <DxColumn
                      data-field="wkfipldt"
                      caption="PFD"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :allow-editing="false" 
                      css-class="grid-header-bold"
                    />
                    <DxColumn 
                      data-field="wkplday" 
                      caption="Days" 
                      width="60" 
                      data-type="string" 
                      alignment="center" 
                      :allow-editing="false"
                      css-class="grid-header-bold"
                    />
                  </DxColumn>
                  <DxColumn caption="Actual Result (Sub-Assembly)" width="300" alignment="center" css-class="grid-header-bold">
                    <DxColumn
                      data-field="actualpsd"
                      caption="PSD"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      css-class="grid-header-bold"
                      :allow-editing="true" 
                    />
                    <DxColumn
                      data-field="actualpfd"
                      caption="PFD"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :allow-editing="true" 
                      css-class="grid-header-bold"
                    />
                    <DxColumn 
                      data-field="actualday" 
                      caption="Days" 
                      width="60" 
                      data-type="string" 
                      alignment="center" 
                      :allow-editing="false"
                      css-class="grid-header-bold"
                    />
                  </DxColumn>
                  <DxColumn caption="Assembly Plan" width="240" alignment="center" css-class="grid-header-bold">
                    <DxColumn
                      data-field="uamidpsd"
                      caption="Mid PSD (UA)"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :allow-editing="false"
                      css-class="grid-header-bold"
                    />
                    <DxColumn
                      data-field="assmidpfd"
                      caption="Mid PFD"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :allow-editing="false"
                      css-class="grid-header-bold"
                    />
                  </DxColumn>
                  <DxColumn
                    data-field="temp"
                    :caption="$t(' ')"
                    data-type="string"
                    alignment="center"
                    css-class="grid-header-bold"
                    :allow-editing="false">
                  </DxColumn>
                </DxDataGrid>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import iButton from '@/components/common/iButton'
import DxDateBox from 'devextreme-vue/date-box'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import { 
         search7010List, 
         getShipNo, 
         UpdateBlockSchedule, 
         getEmpNo } from '@/api/view/pp/20/v20d7010.js'
import { getCmCode, getCmChildCode} from '@/api/system/cmCodeManage'
import moment from 'moment'
import {getDateFormat, getCurrentDate } from '@/utils/common.js'

export default {
  name: 'v20d7010pc',
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    iButton
  },
  data() {
    const today = new Date();
    return {
      dxDataGridRef: 'dxDataGridRef',
      bas0010MainGrid: [],
      listClickData: null,

      checkBoxesMode: 'onClick', // themes.current().startsWith('material') ? 'always' : 'onClick',
      //Common code combo box list
      codegrList: [],

      //Date
      FDate: today,
      FDateStr: this.getStrFormat(today),
      TDate: today,
      TDateStr: this.getStrFormat(today),

      listShip: [],
      listRShip: [],
      shipNo: '%',
      block: '',
      writeYn: this.$gUtil.getWriteYn(),
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.dxDataGridRef)
    },


  },
  methods: {
    limitInput() {
      if (this.block.length > 4) {
        this.block = this.block.slice(0, 4); // Cắt chỉ giữ lại 4 ký tự đầu tiên
      }
    },
    uppercase() {
      this.block = this.block.toUpperCase(); // Chuyển thành chữ in hoa
    },
    getStrFormat(date) {
      this.movDate = date
      return getDateFormat(date)
    },
    async setCombo() {      

      let params = { inShipNO: '' }
      // getShipNo
      const ship = async () => {
        await getShipNo(params).then(result => {
          result.list.forEach(item => {
            this.listShip.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }
      
      await Promise.all([ship()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })

    },
    //PK part modification[edit] function control
    bas0010EditingStart(e) {
       this.gridMainInstance.selectRows(e.data.id, true)
      if (e.data.__created__ === false) {
        if ( e.column.dataField === 'shipno' || e.column.dataField === 'fday' || e.column.dataField === 'fhhmm' ) {
          e.cancel = true
        }
      } else {
        if (e.column.dataField === 'shipnm' ) {
          e.cancel = true
        }
      }
    },
    cellPrepared(e) {

      if (e.rowType === 'data') {
        if (e.rowIndex >= 0) {
          // console.log('e.data.__created__', e.data.__created__)
          if (!e.data.__created__) {
            if ( e.column.dataField === 'shipno' )  {
              e.cellElement.classList.add('cancel-editable-cell')
            }
          }
        }

        //Merge Ship No
        if ( e.column.dataField === 'shipno' )  {
            const rows = e.component.getVisibleRows();
            const rowIndex = e.rowIndex;

            if (
                rowIndex > 0 &&
                rows[rowIndex - 1].rowType === "data" &&
                rows[rowIndex - 1].data.shipno === e.data.shipno
            ) {
                e.cellElement.style.display = "none";
                return;
            }

            let rowSpan = 1;

            for (let i = rowIndex + 1; i < rows.length; i++) {

                if (
                    rows[i].rowType === "data" &&
                    rows[i].data.shipno === e.data.shipno
                ) {
                    rowSpan++;
                } else {
                    break;
                }
            }

            if (rowSpan > 1) {
                e.cellElement.rowSpan = rowSpan;
                e.cellElement.style.verticalAlign = "middle";
            }
          }
      }


      if (e.rowType === "header" && e.column.dataField === "ppWeight")   {
        const text = e.cellElement.querySelector(".dx-datagrid-text-content");

        if (text) {
            text.innerHTML = "PP<br>Weight";
            text.style.whiteSpace = "normal";
            text.style.lineHeight = "18px";
        }
      }
    },
    btnSearch() {
      this.doSearchMainList()
    },
    doSearchMainList(event) {
      this.bas0010MainGrid = []
      this.listClickData = null

      if (!this.shipNo) {
          this.vToastify(this.$t('Please select Ship No!!!'), 'warn')
          return
      }

      this.openLoading('searching')
      let params = {}
      if (event) {
        params = {
          inShipNO: '',
          inBlock:'',
          inFDate: '',
          inTDate: '',
          userId:   this.$store.state.user.userId
        }

      } else {
        params = {
          inShipNO: this.shipNo,
          inBlock: this.block,
          inFDate: this.FDateStr,
          inTDate: this.TDateStr,
          userId:   this.$store.state.user.userId

        }
      }
      
      console.log('pram', params)

      search7010List(params)
          .then(res => {
            this.bas0010MainGrid = res.list  
             //this.setSign(this.tugBoat)
          })
          .finally(() => {                      
            this.endLoading()          
          })
      
    },
    async btnSave() {

        if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Save.'), 'warn')
          return
        }

        let message = ''
         await this.gridMainInstance.saveEditData()

        //let selectedMainRows = []

        const selectedMainRows =  await this.gridMainInstance.getSelectedRowsData()

        console.log('selectedMainRows', selectedMainRows)

        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }


        //Validity check
        for (let row of selectedMainRows) 
        {

            let params = {
                inShipNO: row.shipno,
                inBlock:  row.block,
                inLotNo:  row.lotno,
                inActPSD: this.getStrFormat(row.actualpsd), 
                inActPFD: this.getStrFormat(row.actualpfd), 
                userId:   this.$store.state.user.userId
              }
            console.log('pram', params)

            UpdateBlockSchedule(params).then(res => {                
                      console.log('Save', res.body)
                      if (res.body != 'OK') {
                          this.vToastify(this.$t('An error has been occured while saving data. ' + res.body ), 'warn')
                      }
                  })
                      .catch(error => {
                          this.vToastify(error, 'warn')
                      })
                      .finally(() => {               
                          this.dialogNew = false;   
                      })
        }
        
        this.vToastify(this.$t('Saved successful!'), 'warn')
    },

  },
  created() {
    this.setCombo()
  },
  beforeMount() {
    let param = {
      makerCd: this.$store.state.user.makerCd,
      code: '',
      codegr: '',
      prtCode: 'TIME_FULL',
      userFlag: 'Y'
    }
    //tugTimeList
    Promise.all([getCmChildCode(param)])
      .then(res => {
        res[0].list.forEach(e => {
          if (e.codeName != null) {
            e.timeNm = e.codeName.substring(0, 2) + ':' + e.codeName.substring(2)
          } else {
            e.timeNm = ''
          }
        })

        this.tugTimeList = res[0].list
      })
      .catch(error => {})
  }
}
</script>

<style lang="less">
  #bas0010MainGrid .dx-header-row .grid-header-bold {
      color: #000080 !important;
      font-size: 15px !important;
  }

#bas0010MainGrid .dx-editor-cell .editable-no-border {
    border: none !important;
    box-shadow: none !important;
}
#bas0010MainGrid .dx-editor-cell.editable-no-border.dx-focused {
    border: none !important;
    box-shadow: none !important;
}
._label {
    margin: 0 10px;
    line-height: 30px;
      font-size: 15px !important;
    font-weight: bold;
    color: black;
}

</style>
